import { render, staticRenderFns } from "./CmgDietaryFiltersModal.vue?vue&type=template&id=327888d0&scoped=true&lang=pug"
import script from "./cmg-dietary-filters-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-dietary-filters-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgDietaryFiltersModal.vue?vue&type=style&index=0&id=327888d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327888d0",
  null
  
)

export default component.exports